import { useState, useRef } from 'react';
import './PopOver.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';

import ConfirmMofal from 'components/ConfirmModal/ConfirmMofal';

function PopOver({ props, onHidePopOver, show }) {
  const { top = 0, height = 0, left = 0 } = props;
  const [showConfirm, setShowConfirm] = useState(false);
  const closePopOverBtn = useRef();
  const popOverRef = useRef();

  const style = {
    top: props ? top + height : 0,
    left: props ? left : '',
    zIndex: 999,
  };

  if (!show) {
    return null;
  }
  return (
    <>
      <div className='pop_over' ref={popOverRef} style={style}>
        <div className='pop_header'>
          <span>List Actions</span>
          <div
            ref={closePopOverBtn}
            onClick={onHidePopOver}
            className='pop_over_close_btn'
          >
            <FontAwesomeIcon icon={solid('xmark')} />
          </div>
        </div>
        <div className='action_item'>Add card</div>
        <div
          onClick={() => {
            setShowConfirm(true);
          }}
          className='action_item'
        >
          Delete Column
        </div>
        <div className='action_item'>Move all card in this column</div>
        <div className='action_item'>Archive all card in this column</div>
      </div>
      <ConfirmMofal
        open={showConfirm}
        onSetConfirm={setShowConfirm}
        onHidePopOver={onHidePopOver}
      />
    </>
  );
}

export default PopOver;
